<template>
    
    <!-- Layout Footer -->
    <a-layout-footer>
        <a-row type="flex">
            <a-col :span="24" :md="12">
                <!-- Footer Copyright Notice -->
                <p class="copyright">
                    © 2021, TranSoft
                </p>
                <!-- / Footer Copyright Notice -->
            </a-col>
        </a-row>

        <a-col :span="24" :md="12" class="footer-control">

            <!-- Footer Navigation Menu -->
				<a-menu mode="horizontal">
					<a-menu-item><a href="" target="_blank">About Us</a></a-menu-item>
					<a-menu-item><a href="" target="_blank">Licenses</a></a-menu-item>
				</a-menu>
				<!-- / Footer Navigation Menu -->
        </a-col>
       

    </a-layout-footer>
    <!-- / Layout Footer -->

</template>

<script>
export default {
    
}
</script>